import { AppName } from './types';

export default {
  app: {
    favicon: `${process.env.PUBLIC_URL}/favicons/${AppName.HWT_STUDENT}.ico`
  },
  header: {
    title: 'Handwriting Without Tears®',
    image: '',
    backgroundColor: '#fff6ab',
    textColor: '#000000',
    appNameTitle: `${AppName.HWT_STUDENT}`,
    displayAccessibilitySettings: false
  },
  body: {
    backgroundColor: '#9ec2f4'
  },
  buttons: {
    clearPin: {
      textColor: '#004F90'
    },
    go: {
      backgroundColor: '#005BBB',
      textColor: '#FFF'
    }
  },
  links: {
    about: {
      textColor: '#004F90'
    },
    support: {
      textColor: '#004F90'
    }
  }
};
